import Model from './Model';

export default class StudyLevel extends Model {
    name;

    static apiPath() {
        return 'study-levels';
    }
}



// WEBPACK FOOTER //
// ./src/models/StudyLevel.js